<template>
  <div class="spiner">
    <svg viewBox="25 25 50 50" class="circular">
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        class="path"
        :style="{ stroke: color }"
      ></circle>
    </svg>
    <slot>
      <span class="spinner-text" :style="{ color: color }">{{ text }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    text: {
      type: String,
      default: "Loading...",
    },
    color: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style lang="scss" scoped>
.spiner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.spiner .circular {
  height: 42px;
  width: 42px;
  animation: spiner-loading-rotate 1.5s linear infinite;
}

.spiner .path {
  animation: spiner-loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke-linecap: round;
}

.spinner-text {
  line-height: 30px;
  margin-top: 10px;
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 14px !important;
  font-weight: bold;
}

@keyframes spiner-hide {
  100% {
    opacity: 0;
  }

  0% {
    opacity: 1;
  }
}

@-webkit-keyframes spiner-hide {
  100% {
    opacity: 0;
  }

  0% {
    opacity: 1;
  }
}

@-webkit-keyframes spiner-loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spiner-loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes spiner-loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}

@keyframes spiner-loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
</style>
